import { createIcon } from '../icon'
import ArrowDownIcon from '../svg/ArrowDownIcon'

export const ArrowDownIconDefault = createIcon(ArrowDownIcon)
